<template>
  <div
    v-if="showName"
    :class="$style.container"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 10" v-if="item.beta" :class="$style.betaTag" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M5.522 5.383h-1.56v1.8h1.56a1.434 1.434 0 00.874-.214.796.796 0 00.277-.673.834.834 0 00-.277-.691 1.395 1.395 0 00-.874-.222zM6.52 3.67a.752.752 0 00-.282-.64 1.425 1.425 0 00-.86-.213H3.962v1.706h1.415q1.142 0 1.142-.852z" fill="#353f44" fill-rule="evenodd"/><path d="M25.744 0H1.256A1.256 1.256 0 000 1.256v7.488A1.256 1.256 0 001.256 10h24.488A1.256 1.256 0 0027 8.744V1.256A1.256 1.256 0 0025.744 0zM7.171 7.596a2.394 2.394 0 01-1.53.439H2.888v-6.07h2.668a2.323 2.323 0 011.474.423 1.397 1.397 0 01.537 1.163 1.4 1.4 0 01-.25.831 1.425 1.425 0 01-.695.516 1.506 1.506 0 01.813.536 1.541 1.541 0 01.286.947 1.468 1.468 0 01-.55 1.215zm5.367-4.76H9.555v1.679h2.804v.868H9.555v1.782h2.983v.87H8.481v-6.07h4.057zm3.843 5.199h-1.108V2.87h-1.978v-.905h5.072v.905h-1.986zm6.63 0l-.604-1.424h-2.966l-.614 1.423h-1.108l2.745-6.069h.895l2.753 6.07z" fill="#353f44" fill-rule="evenodd"/><path fill="#353f44" fill-rule="evenodd" d="M19.807 5.759h2.234l-1.117-2.6-1.117 2.6z"/></svg>
    <div
      v-if="showGenericIcon"
      :class="$style.genericIconContainer"
    >
      <span
        :class="$style.genericIconLetter"
        :style="{ backgroundColor: item.logo.color }"
      >
        {{ firstLetter }}
      </span>
      <span
        :class="$style.genericIconText"
        :title="item.displayLabel"
      >
        {{ shortenedText('displayLabel') }}
      </span>
    </div>
    <img
      v-else
      :class="$style.image"
      :src="item.logo.url"
    >
  </div>
  <div
    v-else-if="showDisplayLabel"
    :title="showFullText"
  >
    {{ shortenedText(field) }}
  </div>
</template>
<script>
export default {
  name: 'ApplicationShortenedText',

  props: {
    field: {
      type: String,
      required: true,
    },
    item: {
      required: true,
      type: Object,
    },
  },

  computed: {
    firstLetter() {
      return this.item.displayLabel.charAt(0).toUpperCase();
    },

    showDisplayLabel() {
      return this.field === 'displayLabel';
    },

    showFullText() {
      return this.showName ? this.item.name : this.item.displayLabel;
    },

    showGenericIcon() {
      return this.item.logo.color && this.item.displayLabel;
    },

    showName() {
      return this.field === 'name';
    },
  },

  methods: {
    shortenedText(itemField) {
      let text = this.item[itemField];
      if (text.length > 30) {
        text = text.substr(0, 30);
        text += '...';
      }
      return text;
    },
  },
};
</script>
<style module>
@value (labelText) from '~css/colors.css';

.container {
  min-width: 140px;
}

.betaTag {
  display: block;
  height: 8px;
  width: 27px;
}

.genericIconContainer {
  height: 28px;
  line-height: 28px;
  margin: 3px 0 10px 0;
}

.genericIconLetter {
  border-radius: 14px;
  color: white;
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  width: 28px;
}

.genericIconText {
  color: labelText;
  font-size: 15px;
  font-weight: bold;
  margin-left: 10px;
}

.image {
  display: inline-block;
  margin-right: 4px;
  max-height: 40px;
  max-width: 130px;
  vertical-align: middle;
}
</style>
